/**
 * The situation itself. Authored HTML from `content/situations/**.json`, the
 * same trust boundary as an exercise file or a theory file — written by a
 * grown-up and read before it ships. Nothing a learner types ever reaches this
 * component; their answers live in plain `<textarea>` values.
 */
export function SituationStory({
  html,
  className = "",
}: {
  html: string;
  className?: string;
}) {
  return (
    <div
      className={`situation-story space-y-3 text-[1.05rem] leading-relaxed ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
